var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attr-row"},[_c('div',{staticClass:"attr-label",style:(_vm.attrLabelStyle)},[_vm._v(_vm._s(_vm.label)+" "),_vm._t("hint")],2),_c('div',{style:([_vm.attrValueStyle, _vm.valStyle])},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }